import React, {CSSProperties} from "react";
import {AppBar, IconButton, Toolbar, Typography} from "@mui/material";

interface Props {
    leftElement?: React.ReactNode
    label?: string;
    rightElement?: React.ReactNode
}

export function TopNav({leftElement, label, rightElement}: Props) {
    const topNavStyle: CSSProperties = {
        position: "fixed",
        top: 0,
        height: 72,
        zIndex: 1000,
        display: "flex",
        justifyContent: "flex-end",
        backgroundColor: "white",
        paddingTop: 8,
        paddingLeft: 8,
        paddingRight: 8,
        paddingBottom: 8,
        boxShadow: "none"
    };

    const padding = () => {
        return (<IconButton disabled={true}>
            <div style={{padding: 8, width: "1.5em", height: "1.5em"}}></div>
        </IconButton>)
    }
    return (<>
        <AppBar id="header" position="fixed" component="nav" style={topNavStyle} elevation={1}>
            <Toolbar>
                {leftElement ? leftElement : padding()}
                <Typography variant="h6" style={{flexGrow: 1, textAlign: "center", color: "#1B4A95"}}>
                    {label && label}
                </Typography>
                {rightElement ? rightElement : padding()}
            </Toolbar>
        </AppBar>
        <Toolbar sx={{height: 72}}/>
    </>);
}